<template>
  <div class="wrapper">
    <div class="banner"></div>
    <div class="container">
      <div class="search">
        <div class="search-box">
          <el-input placeholder="请输入检索词..." v-model="inputValue" class="input-group" maxlength="100" @keyup.enter.native="handleSearch">
            <el-select class="select-group" v-model="selectValue" slot="prepend" placeholder="请选择">
              <el-option v-for="m in options" :key="m.fieldname" :label="m.displayname" :value="m.fieldname">
              </el-option>
            </el-select>
          </el-input>
          <div class="line"></div>
          <div class="search-icon cp" @click="handleSearch"></div>
        </div>
      </div>
      <div class="list">
        <!-- 红色故事 -->
        <el-row>
          <el-col :span="24">
            <div class="images-story">
              <div class="more" @click="moreSearchFn('story')"></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="images-library"></div>
          </el-col>
          <el-col :span="18">
            <div class="story-list">
              <ul class="list-box">
                <li class="list-item" v-for="(item, index) in rowsHS" :key="index + 'id'" >
                  <span class="list-name" maxlength="10" :title="item.name" @click="detailFn(item)">{{ item.name }}</span>
                  <span class="list-author" :title="item.author">{{ item.author }}</span>
                  <span class="list-time">{{ item.publicationTime.slice(0, 10) }}</span>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <!-- 遗存物品 -->
        <el-row>
          <el-col :span="24">
            <div class="images-remains">
              <div class="more" @click="moreSearchFn('remains')"></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="images-star"></div>
          </el-col>
          <el-col :span="18">
            <div class="story-list">
              <ul class="list-box">
                <li class="list-item" v-for="(item, index) in rowsYC" :key="index + 'id'">
                  <span class="list-name" maxlength="10" :title="item.name" @click="detailFn(item)">{{ item.name }}</span>
                  <span class="list-author" :title="item.author">{{ item.author }}</span>
                  <span class="list-time">{{ item.publicationTime.slice(0, 10) }}</span>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <!-- 雨花英烈 -->
        <el-row>
          <el-col :span="24">
            <div class="images-hero">
              <div class="more" @click="moreSearchFn('hero')">更多></div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="story-list">
              <ul class="list-box">
                <li class="list-item" v-for="(item, index) in rowsYL" :key="index + 'id'">
                  <span class="list-name" maxlength="10" :title="item.name"  @click="detailFn(item)">{{ item.name }}</span>
                  <span class="list-author" :title="item.author">{{ item.author }}</span>
                  <span class="list-time">{{ item.publicationTime.slice(0, 10) }}</span>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="footer">
      <p>版权所有：南京市雨花台烈士陵园管理局</p>
      <p>技术支持：同方知网数字出版技术股份有限公司</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RedHero",
  data() {
    return {
      inputValue: "",
      selectValue: "主题",
      options: [],
      rowsHS: [],
      rowsYC: [],
      rowsYL: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getinfo()
      this.getSelectData()
    },
    // 获取搜索栏下拉框
    getSelectData() {
      axios.get('/yuhuamenhu/special/getAllQueryCriteria').then(res => {
        if (res.status === 200) {
          this.options = JSON.parse(JSON.stringify(res.data.data))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取3个模块信息
    getinfo() {
      axios
        .get("/yuhuamenhu/special/getYHYLYJSpecialData")
        .then((res) => {
          if (res.status === 200) {
            const data = JSON.parse(JSON.stringify(res.data.data))
            this.rowsHS = data.rowsHS;
            this.rowsYC = data.rowsYC;
            this.rowsYL = data.rowsYL;

          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索栏 检索
    handleSearch() {
      const search = this.$router.resolve({
        path: '/moreSearch',
        query: {
          module: '雨花英烈研究',
          fieldName: this.selectValue,
          queryName: this.inputValue
        }
      })
      window.open(search.href, '_blank')
    },
    // 点击更多进去检索页面
    moreSearchFn(val) {
      let param = ''
      switch (val) {
        case 'story':
          param = '红色故事'
          break;
        case 'remains':
          param = '遗存物品'
          break;
        case 'hero':
          param = '雨花英烈精神'
          break;
      }
      const search = this.$router.resolve({
        path: '/moreSearch',
        query: {
          module: '雨花英烈研究',
          type: param,
          fieldName: this.selectValue,
          queryName: this.inputValue

        }
      })
      window.open(search.href, '_blank')
    },
    // 详情
    detailFn (val) {
      const detail = this.$router.resolve({
        path: "/yjztDetail",
        query: {
          name: val.name,
          from: val.from
        }
      });
      window.open(detail.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(189deg, #fce7c8, #efeae6);
  padding-bottom: 50px;
  overflow: auto;

  .banner {
    position: absolute;
    width: 100%;
    height: 810px;
    top: 0;
    background-image: url("./images/banner.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .container {
    position: relative;
    width: 1200px;
    margin: 476px auto 0;
    padding: 52px 51px 0;
    background: rgba(255, 255, 255, 0.78);

    .search {
      margin-left: 213px;
      margin-bottom: 42px;
    }

    .list {
      // position: absolute;
      // top: 154px;
    }
  }

  .footer {
    text-align: center;
    margin-top: 50px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
  }
}

.story-list {
  margin-top: 43px;
  margin-bottom: 90px;
}

.images-story {
  position: relative;
  width: 1100px;
  height: 56px;
  background: url(./images/story.png) no-repeat;
  background-size: 100% 100%;
}

.images-library {
  position: relative;
  width: 170px;
  height: 240px;
  background: url(./images/library.png) no-repeat;
  background-size: 100% 100%;
}

.images-remains {
  position: relative;
  width: 1100px;
  height: 56px;
  background: url(./images/remains.png) no-repeat;
  background-size: 100% 100%;
}

.images-star {
  position: relative;
  width: 170px;
  height: 240px;
  background: url(./images/star.png) no-repeat;
  background-size: 100% 100%;
}

.images-hero {
  position: relative;
  width: 1100px;
  height: 56px;
  background: url(./images/hero.png) no-repeat;
  background-size: 100% 100%;
}

.more {
  position: absolute;
  width: 63px;
  height: 23px;
  // background: #000;
  right: 0;
  top: 37%;
  color: #fff;
  letter-spacing: 1px;
  cursor: pointer;
}

.list-box {
  .list-item {
    display: flex;
    justify-content: space-between;
  }

  .list-name {
    font-size: 18px;
    width: 60%;
    font-weight: bold;
    color: #333333;
    line-height: 48px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    cursor: pointer;
  }

  .list-author {
    width: 20%;
    font-size: 18px;
    font-weight: 400;
    color: #555555;
    line-height: 48px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }

  .list-time {
    width: 102px;
    font-size: 18px;
    font-weight: 400;
    color: #555555;
    line-height: 48px;
  }
}
</style>
<style scoped>
@import '../search.css';
</style>
